import { render, staticRenderFns } from "./EmailConfiguration.vue?vue&type=template&id=85f51656"
import script from "./EmailConfiguration.vue?vue&type=script&lang=js"
export * from "./EmailConfiguration.vue?vue&type=script&lang=js"
import style0 from "./EmailConfiguration.vue?vue&type=style&index=0&id=85f51656&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports